module.exports = __webpack_public_path__ + "static/media/icon_botebasura24px.ced746c5.svg";